'use client';
import React from 'react';

import UtilityService from '@/services/util/utility-service';

interface Props {
  isAdmin?: boolean;
  inviteToken?: string;
  disabled?: boolean;
}

const redirectBase =
  process.env.NODE_ENV === 'development'
    ? (process.env.NEXT_PUBLIC_API_URL_DEVELOPMENT as string)
    : UtilityService.getApiUrl();

function MicrosoftLoginButton({
  isAdmin = false,
  inviteToken,
  disabled = false,
}: Props): React.JSX.Element {
  const onClick = () => {
    if (disabled) return;

    const tenant = (process.env.NEXT_PUBLIC_MS_TENANT as string) || 'common';
    const clientId = process.env.NEXT_PUBLIC_MS_CLIENT_ID as string;
    if (!clientId) {
      console.error('Missing NEXT_PUBLIC_MS_CLIENT_ID');
      return;
    }

    const base = redirectBase.endsWith('/') ? redirectBase : `${redirectBase}/`;
    const redirectUri = inviteToken
      ? `${base}auth/microsoft/signup/invite`
      : `${base}auth/${isAdmin ? 'microsoft/admin/login' : 'microsoft/login'}`;

    const authUrl = new URL(`https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize`);
    authUrl.searchParams.set('client_id', clientId);
    authUrl.searchParams.set('response_type', 'code');
    authUrl.searchParams.set('redirect_uri', redirectUri);
    authUrl.searchParams.set('response_mode', 'query');
    authUrl.searchParams.set('scope', 'openid profile email offline_access User.Read');
    const state = {
      origin: typeof window !== 'undefined' ? window.location.origin : '',
      inviteToken,
    };
    authUrl.searchParams.set('state', JSON.stringify(state));

    window.location.href = authUrl.toString();
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className='bg-white font-medium text-neutral-800 inline-flex items-center justify-center whitespace-nowrap rounded-2xl shadow-sm border border-slate-200 px-4 py-3 w-full max-w-none disabled:opacity-50'
    >
      {/* Simple MS logo squares */}
      <span
        className='mr-2 grid grid-cols-2 gap-[2px]'
        aria-hidden
        style={{ width: 18, height: 18 }}
      >
        <span style={{ background: '#F25022', width: 8, height: 8 }} />
        <span style={{ background: '#7FBA00', width: 8, height: 8 }} />
        <span style={{ background: '#00A4EF', width: 8, height: 8 }} />
        <span style={{ background: '#FFB900', width: 8, height: 8 }} />
      </span>
      {inviteToken ? 'Continue with Microsoft' : 'Sign in with Microsoft'}
    </button>
  );
}

export default MicrosoftLoginButton;
